import { useState, useEffect } from 'react';
import { useConsultantContext } from '@/context/ConsultantContext';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useAllUsers from '@/services/global-services/query/useAllUsers';
import { useToast } from '../../../organisms/feedback/use-toast';
import { useAuthContext } from '@/context/AuthContext';


const useConsultant = () => {
    const { getAllUsers, allUsers, error } = useAllUsers();
    const [users, setUsers] = useState();
    const {isBrowsingAllowedTo, fullPath} = useAuthContext();
    const { toast } = useToast();
    const urlDetailsAboutConsultant = [
        {
            url: "/statement",
        },
        {
            url: "/information",
        },
        {
            url: "/cv",
        },
        {
            url: "/payslip",
        },
        {
            url: "/timesheet",
        },
        { url: "/skills",
        },
        {
            url: "/expense",
        },
        {
            url: "/companyBenefit",
        },
    ];

    useEffect(() => {
        getAllUsers();
    }, []);

    useEffect(() => {

        if (allUsers?.length > 0 && !error) {
            // console.log("User data:", data);
            setUsers(allUsers);
            setUsesMatched(allUsers);
            setUsersFormated(allUsers);
        }
        if (error) {
            console.error("Error fetching user:", error);
            toast({
                variant: "error",
                title: "Error",
                description: error,
                duration: 8000,
            });
        }
    }, [allUsers, error])

    const [usersMatched, setUsesMatched] = useState();
    const [usersFormated, setUsersFormated] = useState();

    const [searchText, setSearchText] = useState('');
    const [isSelected, setIsSelected] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { activeUser, setActiveUser } = useConsultantContext();

    const searchConsultant = (text) => {
        setSearchText(text);
        const filteredUsers = users.filter((user) =>
            user.firstname.toLowerCase().includes(text.toLowerCase()) ||
            user.lastname.toLowerCase().includes(text.toLowerCase()) ||
            user.trigram.toLowerCase().includes(text.toLowerCase())
        );
        console.log("filteredUsers: ", filteredUsers, "users: ", users);
        setUsesMatched(filteredUsers);
    };

    const clearSearch = () => {
        setSearchText('');
        setUsesMatched([]);
    };

    const initActivesUsersFromUrl = () => {
        if (!activeUser[0] && users) {
            const tempActiveUser = users.filter((u) => u.uuid == id)
            setActiveUser(tempActiveUser[0]);
        }
    }
    useEffect(() => {
            activeUser ? initActivesUsersFromUrl() : setActiveUser(users?.filter((u) => u.uuid == id)[0]);
    }, [users, id])


    const handleClick = (user) => {
        setIsSelected(true);
        setActiveUser(user);
        if (id) {
            const newPath = location.pathname.replace(id, user.uuid);
            navigate(newPath, { replace: true });
        } else {
            let redirected = false;
            for (let i = 0; i < urlDetailsAboutConsultant.length; i++) {
                const url = user.uuid + urlDetailsAboutConsultant[i].url;
                if (isBrowsingAllowedTo(fullPath(url))) {
                    navigate(url);
                    redirected = true;
                    break;
                }
            }
            if (!redirected) {
                navigate(user.uuid + urlDetailsAboutConsultant[0].url);
            }
        }
    };

    return { usersFormated, usersMatched, searchText, isSelected, searchConsultant, clearSearch, handleClick };
};

export default useConsultant;
